type PostgresPoolConfig = {
  max: number;
  idleTimeout: number;
  connectionTimeout: number;
};

function readPositiveIntEnv(env: Record<string, string | undefined>, key: string, fallback: number): number {
  const value = Number(env[key]);
  return Number.isInteger(value) && value > 0 ? value : fallback;
}

function readNonNegativeIntEnv(
  env: Record<string, string | undefined>,
  key: string,
  fallback: number,
): number {
  const value = Number(env[key]);
  return Number.isInteger(value) && value >= 0 ? value : fallback;
}

export function resolvePostgresPoolConfig(
  env: Record<string, string | undefined> = process.env,
): PostgresPoolConfig {
  return {
    max: readPositiveIntEnv(env, "GENCOW_DB_MAX_CONNECTIONS", 10),
    idleTimeout: readPositiveIntEnv(env, "GENCOW_DB_IDLE_TIMEOUT_SECONDS", 30),
    connectionTimeout: readPositiveIntEnv(env, "GENCOW_DB_CONNECTION_TIMEOUT_SECONDS", 10),
  };
}

export function resolvePostgresOperationTimeoutMs(
  env: Record<string, string | undefined> = process.env,
): number {
  return readNonNegativeIntEnv(env, "GENCOW_DB_OPERATION_TIMEOUT_MS", 25_000);
}
